// Third party
import React, { Component } from 'react';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';

// Actions
import { authorizeOAuth2 } from '../../../../redux/modules/auth';
import Dictionary from '@/types/dictionary';

type DispatchProps = {
  authorizeOAuth2: (code: string, providerName: string) => Promise<void>;
};

type State = {
  loaded: boolean;
};

type Props = RouteComponentProps & DispatchProps;

class OAuth2Success extends Component<Props, State> {
  readonly state: State = {
    loaded: false,
  };

  async componentDidMount() {
    await this.authorize();
  }

  async authorize() {
    const {
      location: { search },
    } = this.props;
    const { code, state: redirectStateStr } = qs.parse(search, { ignoreQueryPrefix: true }) as Dictionary<string>;
    const redirectState = JSON.parse(redirectStateStr);
    await this.props.authorizeOAuth2(code, redirectState.name);
    this.setState({ loaded: true });
  }

  render() {
    if (this.state.loaded) {
      const {
        location: { search },
      } = this.props;
      const { state: redirectStateStr } = qs.parse(search, { ignoreQueryPrefix: true }) as Dictionary<string>;
      const redirectState = JSON.parse(redirectStateStr);
      const redirect = redirectState.path ? redirectState.path : '/';
      return <Redirect to={redirect} />;
    }
    return '';
  }
}

export default withRouter(
  connect(null, {
    authorizeOAuth2,
  })(OAuth2Success),
);
